import React, { useEffect, useState } from 'react';
import { Button, Card, DatePicker, Select, Table, Tag } from 'antd';
import dayjs from 'dayjs';
import { useAttendance } from '../../hooks/useAttendance';
import { useEmployees } from '../../hooks/useEmployees';
import { AttendanceStatus } from '../../types';

const { Option } = Select;

const statusColor: Record<AttendanceStatus, string> = {
  PRESENT: 'green', ABSENT: 'red', HALF_DAY: 'orange', ON_LEAVE: 'blue', PUBLIC_HOLIDAY: 'purple',
};

const AttendanceView: React.FC = () => {
  const [selectedEmployee, setSelectedEmployee] = useState<number | null>(null);
  const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs]>([
    dayjs().startOf('month'), dayjs().endOf('month'),
  ]);
  const [records, setRecords] = useState<any[]>([]);
  const { fetchByEmployee, fetchByDateRange } = useAttendance();
  const { employees, fetchEmployees } = useEmployees();

  useEffect(() => { fetchEmployees(); }, []);

  const handleLoad = async () => {
    const from = dateRange[0].format('YYYY-MM-DD');
    const to = dateRange[1].format('YYYY-MM-DD');
    const data = selectedEmployee
      ? await fetchByEmployee(selectedEmployee, from, to)
      : await fetchByDateRange(from, to);
    setRecords(data ?? []);
  };

  const columns = [
    { title: 'Date', dataIndex: 'attendanceDate', key: 'attendanceDate', width: 110 },
    ...(selectedEmployee
      ? []
      : [{ title: 'Employee', dataIndex: 'employeeName', key: 'employeeName' }]),
    { title: 'Check In', dataIndex: 'checkIn', key: 'checkIn', width: 90 },
    { title: 'Check Out', dataIndex: 'checkOut', key: 'checkOut', width: 90 },
    { title: 'Hours', dataIndex: 'hoursWorked', key: 'hoursWorked', width: 70 },
    {
      title: 'Status', dataIndex: 'status', key: 'status',
      render: (s: AttendanceStatus) => <Tag color={statusColor[s]}>{s}</Tag>,
    },
    { title: 'Remarks', dataIndex: 'remarks', key: 'remarks', ellipsis: true },
  ];

  return (
    <div className="p-6">
      <Card title="Attendance Records">
        <div className="flex gap-4 mb-4 flex-wrap">
          <Select
            placeholder="All employees"
            showSearch
            optionFilterProp="children"
            allowClear
            style={{ width: 260 }}
            onChange={setSelectedEmployee}
          >
            {employees.map((e) => (
              <Option key={e.id} value={e.id}>{e.firstName} {e.lastName}</Option>
            ))}
          </Select>
          <DatePicker.RangePicker
            value={dateRange}
            onChange={(v) => v && setDateRange([v[0]!, v[1]!])}
          />
          <Button type="primary" onClick={handleLoad}>Load</Button>
        </div>
        <Table dataSource={records} columns={columns} rowKey="id" size="small" />
      </Card>
    </div>
  );
};

export default AttendanceView;
